import React from 'react';
import { CtaButton } from '../CtaButton';
import { ProductImage } from '../ProductImage';
import { PriceBlock } from '../PriceBlock';
import { BRAND, CORE_PROMISE } from '../../data/salesContent';
export function FinalCtaSection() {
  return <section className="bg-ink px-5 pb-12 pt-20 md:pt-28" data-id="element-124" data-mp="2ijrbgrpxgrpg">
      <div className="mx-auto max-w-3xl text-center" data-id="element-125" data-mp="2dj3iw1m1w2t4">
        <ProductImage className="mx-auto w-full max-w-xl" data-id="element-126" data-mp="2dlpss7weyuei" />
        <p className="mt-12 text-sm font-bold uppercase tracking-[0.25em] text-gold md:text-base" data-id="element-127" data-mp="2rhth5kklw8j2">{BRAND} presenta</p>
        <p className="mt-3 font-display text-base font-extrabold uppercase tracking-[0.15em] text-neutral-300 md:text-lg" data-id="element-128" data-mp="2mjroc7xdouue">
          Primeros Auxilios para Instructores™
        </p>
        <h2 className="mt-5 font-display text-4xl font-black uppercase leading-tight text-cream md:text-6xl" data-id="element-129" data-mp="2wb5tav83mmux">{CORE_PROMISE}</h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-neutral-400 md:text-xl" data-id="element-130" data-mp="3a7jd4b03v0ck">
          Tené en un solo sistema el método, los contenidos, las prácticas, las simulaciones, las evaluaciones y las herramientas
          necesarias para organizar tus capacitaciones.
        </p>
        <p className="mt-10 font-display text-base font-extrabold uppercase tracking-widest text-cream md:text-lg" data-id="element-131" data-mp="2648yhhwc8rty">3 volúmenes + 5 bonos</p>
        <div className="mt-2" data-id="element-132" data-mp="2g0vjc6onzivz">
          <PriceBlock data-id="element-133" data-mp="2g158xt5sro15" />
        </div>
        <div className="mt-10" data-id="element-134" data-mp="2fxzleictgu7j">
          <CtaButton data-id="element-135" data-mp="2kzylnjd9fb09">Quiero dejar de preparar todo desde cero</CtaButton>
        </div>
      </div>
      <footer className="mx-auto mt-24 max-w-4xl border-t border-ink-line pt-8 text-center" data-id="element-136" data-mp="2p0ii0kq0ealc">
        <p className="font-display text-lg font-extrabold tracking-wide text-gold" data-id="element-137" data-mp="2tr8q45ptkrjq">{BRAND}</p>
        <p className="mt-2 text-sm text-neutral-500" data-id="element-138" data-mp="2yqk97ldns94h">© 2026 {BRAND} · Primeros Auxilios para Instructores™ · Todos los derechos reservados</p>
      </footer>
    </section>;
}